import { render, staticRenderFns } from "./shopPurchaseInfos.vue?vue&type=template&id=d952e07c&scoped=true"
import script from "./shopPurchaseInfos.vue?vue&type=script&lang=js"
export * from "./shopPurchaseInfos.vue?vue&type=script&lang=js"
import style0 from "./shopPurchaseInfos.vue?vue&type=style&index=0&id=d952e07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d952e07c",
  null
  
)

export default component.exports